'use client';

import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

import {useScrollAnalytics} from '@web-catalog/utils/analytics';

export const NavigationEvents = () => {
  const pathname = usePathname();

  const {logScrollDownScroll} = useScrollAnalytics();

  useEffect(() => {
    const scrollDepth = document.documentElement.scrollTop;

    if (scrollDepth > 0) {
      logScrollDownScroll(scrollDepth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
